module.exports = __webpack_public_path__ + "img/icon-close-modal.6ab422b1.svg";